import * as THREE from 'three';

// Loads the Tokyo alley tools/build-alley.mjs cut into lamps - the picture
// with its signs off, the light every sign adds (diff), the lossless id map
// and the per-sign data - once, at startup, for visualizers/neonalley.js.
// Same preload/get shape as rosace-assets.js, and the same rule: the preload
// is a WIRING POINT every entry point must call (main, main-radio,
// main-embedded, play-boot, landing-boot, demo-boot, the capture harness).
// A forgotten one is silent: the getter returns null and the alley stays
// dark.
//
// THE ID MAP IS DATA, NOT A PICTURE: NearestFilter, no mipmaps, no colour
// space. The two photographs are sRGB and decoded by the GPU, which is what
// lets the shader add them in linear light.
const MANIFEST_URL = 'textures/alley.json';

let _assets = null;
let _promise = null;

function loadTexture(url, configure) {
  return new Promise(function (resolve, reject) {
    new THREE.TextureLoader().load(url, function (t) { configure(t); t.needsUpdate = true; resolve(t); }, undefined, function () {
      reject(new Error(url + ' failed to load'));
    });
  });
}

// No mipmaps: the pictures are shown at about their own size, and a mip
// blend over the neon edges lifted the whole frame by 2/255 against
// alley-on (measured through the harness; 0.7/255 without it).
function photo(t) {
  t.colorSpace = THREE.SRGBColorSpace;
  t.generateMipmaps = false;
  t.minFilter = THREE.LinearFilter;
  t.magFilter = THREE.LinearFilter;
  t.wrapS = t.wrapT = THREE.ClampToEdgeWrapping;
}

export function preloadAlley() {
  if (_promise) return _promise;
  _promise = fetch(MANIFEST_URL)
    .then(function (r) {
      if (!r.ok) throw new Error('alley.json HTTP ' + r.status);
      return r.json();
    })
    .then(function (manifest) {
      return Promise.all([
        loadTexture('textures/' + manifest.off, photo),
        loadTexture('textures/' + manifest.diff, photo),
        loadTexture('textures/' + manifest.ids, function (t) {
          t.colorSpace = THREE.NoColorSpace;
          t.generateMipmaps = false;
          t.minFilter = THREE.NearestFilter;
          t.magFilter = THREE.NearestFilter;
          t.wrapS = t.wrapT = THREE.ClampToEdgeWrapping;
        }),
        fetch('textures/' + manifest.data).then(function (r) {
          if (!r.ok) throw new Error(manifest.data + ' HTTP ' + r.status);
          return r.json();
        })
      ]).then(function (parts) {
        _assets = { manifest: manifest, off: parts[0], diff: parts[1], ids: parts[2], data: parts[3] };
        return _assets;
      });
    })
    .catch(function (err) {
      console.error('[party-mode] alley assets unavailable, NeonAlley will stay dark', err);
      _assets = null;
      return null;
    });
  return _promise;
}

export function getAlley() {
  return _assets;
}

// Node tests only: hand in assets without a fetch.
export function _setAlleyForTests(a) { _assets = a; _promise = Promise.resolve(a); }
